module.exports = __webpack_public_path__ + "static/fonts/Metric-Regular.53a1018.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/metric/Metric-Regular.woff
// module id = Oumb
// module chunks = 88